// desktopNotify.js — notifications inside the Mac desktop app.
//
// The desktop shell has no browser push service (webPush.js is off there), but
// its window keeps running in the menu bar, so the realtime pop in
// MessagesUnreadContext can show a native macOS notification through the
// renderer's Notification API. This module is the on/off switch for that,
// kept per machine in localStorage (default on).

const KEY = 'chatrone.desktopNotify'

export const inDesktopShell = () => typeof window !== 'undefined' && !!window.chatroneDesktop

function readPref() {
  try { return localStorage.getItem(KEY) !== 'off' } catch { return true }
}
function writePref(on) {
  try { localStorage.setItem(KEY, on ? 'on' : 'off') } catch { /* private storage */ }
}

// 'unsupported' | 'denied' | 'enabled' | 'disabled'
export function getDesktopNotifyState() {
  if (!inDesktopShell() || typeof Notification === 'undefined') return 'unsupported'
  if (Notification.permission === 'denied') return 'denied'
  if (Notification.permission !== 'granted') return 'disabled'
  return readPref() ? 'enabled' : 'disabled'
}

// True when the realtime pop may show a notification in the desktop app.
export function desktopNotifyOn() {
  return getDesktopNotifyState() === 'enabled'
}

export function showDesktopNotification(title, { body, tag, onClick } = {}) {
  const n = new Notification(title, { body, tag, icon: '/logo-square.png', silent: false })
  n.onclick = () => {
    // window.focus() can't un-hide the shell's window; the bridge can.
    window.chatroneDesktop?.focusWindow?.()
    window.focus()
    onClick?.()
    n.close()
  }
  return n
}

export async function enableDesktopNotify() {
  if (!inDesktopShell() || typeof Notification === 'undefined') {
    throw new Error('Desktop notifications only work in the Chatrone Mac app.')
  }
  const perm = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission()
  if (perm !== 'granted') throw new Error('Notifications are blocked — allow Chatrone in System Settings → Notifications.')
  writePref(true)
  sendTestNotification()
  return 'enabled'
}

export function disableDesktopNotify() {
  writePref(false)
  return 'disabled'
}

export function sendTestNotification() {
  showDesktopNotification('Chatrone', { body: 'Desktop notifications are on. New messages and Janet will show up here.' })
}
